import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EmployeesState, EmployeesStore } from './employees.store';

@Injectable({
  providedIn: 'root',
})
export class EmployeesQuery extends QueryEntity<EmployeesState> {
  selectFilters$ = this.select('filters');
  selectSearchTerm$ = this.select((state) => state.filters.searchTerm);

  get filters() {
    return this.getValue().filters;
  }

  get searchTerm() {
    return this.getValue().filters.searchTerm;
  }

  constructor(protected override store: EmployeesStore) {
    super(store);
  }
}
